import qs from 'qs';
import axios, { AxiosRequestConfig } from 'axios';
import localforage from 'localforage';
import memoryDriver from 'localforage-memoryStorageDriver';
import { setupCache } from 'axios-cache-adapter';
import { Toastr } from '../utils/Toastr';
import { wasteManagementUrls, cacheSettings } from '../appConfig';
import { store } from '../redux/store';
import { locale } from '../common/localization/localizationService';
import EventBus from '../common/EventBus';
import { requestInterceptor } from './interceptors';

const CancelToken = axios.CancelToken;
let cancelTokenSource = CancelToken.source();

const forageStore = localforage.createInstance({
  driver: [
    localforage.INDEXEDDB,
    localforage.LOCALSTORAGE,
    memoryDriver._driver,
  ],
  name: 'waste-management-cache',
});

const cache = setupCache({
  maxAge: cacheSettings.maxAgeSeconds * 1000,
  exclude: { query: false },
  store: forageStore,
  limit: cacheSettings.limit as any,
  key: generateCacheKey,
});

const wasteManagementClient = axios.create({
  baseURL: wasteManagementUrls.baseUrl,
  headers: { 'Content-Type': 'application/json' },
  adapter: cache.adapter,
  paramsSerializer: (params) => {
    return qs.stringify(params);
  },
});

wasteManagementClient.interceptors.request.use(requestInterceptor);

wasteManagementClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
       EventBus.emit('onLogout', { onUnauthorized: true });
    }
    Toastr.error(locale.general._backendError);
    throw error;
  },
);

function generateCacheKey(request: AxiosRequestConfig): string {
  const key = request.url + qs.stringify(request.params);
  const impersonatedUser = store.getState().authentication.impersonatedUser;

  return impersonatedUser ? `${impersonatedUser}@${key}` : key;
}

export function resetClient(): void {
  forageStore.clear();
  cancelTokenSource.cancel('WasteManagement requests cancelled');
  cancelTokenSource = CancelToken.source();
}

export default wasteManagementClient;
export { wasteManagementClient };
